import { Box, FileSelector, LoaderNew, Spacer } from '@jfs/ui-new'
import { TextInput } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { isEmptyObject } from '@jfs/utils'
import { memo, useState } from 'react'
import XlsxPopulate from 'xlsx-populate'
import { BulkOnnboardResponse } from '../../data/models/Merchant'
import { useStores } from '../../data/store'
import { MessageTypes } from '../../utils'

const columns = ['CSO Name', 'CSO Mobile', 'JC Name', 'JC No', 'mid', 'terminalId', 'vpa']

const BulkMerchantOnboarding = memo(() => {
  const {
    bulkAPIGOnboarding,
    bulkInsertMerchant,
    bulkAddConfig,
    bulkAddConfigList,
    bulkCreateVpa,
    bulkGenerateQR,
    setMessage,
    insertCso,
    bulkGrantPermission,
    sampleFileDownload,
  } = useStores((store) => ({
    bulkAPIGOnboarding: store.merchantMapping.bulkAPIGOnboarding,
    bulkInsertMerchant: store.merchantMapping.bulkInsertMerchant,
    bulkAddConfig: store.merchantMapping.bulkAddConfig,
    bulkAddConfigList: store.merchantMapping.bulkAddConfigList,
    bulkCreateVpa: store.merchantMapping.bulkCreateVpa,
    setMessage: store.message.setMessage,
    bulkGenerateQR: store.merchantMapping.bulkGenerateQR,
    insertCso: store.merchantMapping.bulkInsertCso,
    bulkGrantPermission: store.merchantMapping.bulkGrantPermission,
    sampleFileDownload: store.sampleFileDownload,
  }))

  const [mids, setMids] = useState<any>([])
  const [inputKeys, setInputkeys] = useState<String[]>([])
  const [uniqueMids, setUniqueMids] = useState<any>([])
  const [delay, setDelay] = useState(200)
  const [password, setPassword] = useState('')
  const [bulkAPIGOnboardingLoading, setBulkAPIGOnboardingLoading] = useState(false)
  const [bulkGrantPermissionLoading, setBulkGrantPermissionLoading] = useState(false)
  const [bulkInsertMerchantLoading, setBulkInsertMerchantLoading] = useState(false)
  const [bulkAddConfigLoading, setBulkAddConfigLoading] = useState(false)
  const [bulkAddConfigListLoading, setBulkAddConfigListLoading] = useState(false)
  const [bulkCreateVpaLoading, setBulkCreateVpaLoading] = useState(false)
  const [bulkGenerateQRLoading, setBulkGenerateQRLoading] = useState(false)
  const [csoOnboardLoading, setCsoOnboardLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [wsdata, setWsData] = useState<XlsxPopulate.Workbook>()
  const [filename, setFilename] = useState('')

  const isValidEntry = (obj: any) => {
    return !isEmptyObject(obj)
  }
  const readExcel = async (file: any, name: string) => {
    if (!file) {
      setFilename(name)
      setWsData(undefined)
      setMids([])
      return
    }
    setLoading(true)
    const readPromise = new Promise((resolve, reject) => {
      XlsxPopulate.fromDataAsync(file)
        .then(function (workbook) {
          setFilename(name)
          setWsData(workbook)
          const sheet = workbook.sheet(0)
          const rows = sheet._rows
          const keys: string[] = []
          const values: any = []
          const uniqueValues: any = []
          rows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row._cells.length; i++) {
              if (rowIndex === 1) {
                keys.push(`${row._cells[i]?.value() ?? ''}`)
              } else {
                const key = keys[i - 1]
                obj[key] = `${String(row._cells[i]?.value() ?? '')?.trim()}`
              }
            }
            isValidEntry(obj) && values.push(obj)
          })
          let filterdObj: any = {}
          rows?.forEach((element) => {
            const key: any = element?.cell(2)?.value()
            if (!!key && !filterdObj[key]) {
              filterdObj[key] = element
            }
          })
          const filteredRows = Object.values(filterdObj)
          filteredRows.forEach((row: any, rowIndex: number) => {
            const obj: any = {}
            for (let i = 1; i < row?._cells?.length; i++) {
              if (rowIndex !== 0) {
                const key = keys[i - 1]
                obj[key] = `${row?._cells[i]?.value() ?? ''}`
              }
            }
            !isEmptyObject(obj) && uniqueValues.push(obj)
          })
          const isExcelInvalid = columns.some((item) => !keys.includes(item))
          if (!isExcelInvalid) {
            setMids(values)
            setUniqueMids(uniqueValues)
            setInputkeys(keys)
            resolve(values)
          } else {
            reject('Invalid File')
          }
        })
        .catch((e) => {
          reject('Invalid File')
        })
    })
    try {
      await readPromise
    } catch (e) {
      setWsData(undefined)
      setFilename('')
      setMessage(e, MessageTypes.ERROR)
    }
    setLoading(false)
  }

  const onBulkUpload = async (
    apiCall: any,
    loaderFunc: (b: boolean) => void,
    fileName: string,
    isGenerateQr: boolean = false,
    isCreateVpa: boolean = false,
  ) => {
    if (isGenerateQr && !password) {
      setMessage('Please enter Password', MessageTypes.ERROR)
      return
    }
    loaderFunc(true)
    const errorData: BulkOnnboardResponse[] = await apiCall(mids, delay, uniqueMids)
    loaderFunc(false)

    let transformedData = []
    const modifiedMidData = JSON.parse(JSON.stringify(mids))
    modifiedMidData?.forEach((item) => {
      inputKeys?.forEach((key) => {
        if (item[key as keyof typeof item] === undefined) {
          item[key as keyof typeof item] = ''
        }
      })
    })
    if (isGenerateQr) {
      transformedData = errorData.map((item) => [
        item.name,
        item.businessLegalName,
        item.mobile,
        item.UPIQRUrl,
        item.address,
        item.pincode,
        item.status,
        item.message,
        item.code,
      ])
      transformedData.splice(0, 0, [
        'Name',
        'Business Legal Name',
        'Mobile',
        'UPI QR URL',
        'Address',
        'pincode',
        'Result',
        'Message',
        'Error code',
      ])
    } else {
      if (isCreateVpa) {
        modifiedMidData.forEach((item, index) => {
          item.vpa = errorData[index].vpa
        })
      }
      transformedData = errorData.map((item) => [item.status, item.message, item.code])
      transformedData.splice(0, 0, ['Result', 'Message', 'Error code'])
    }
    if (isGenerateQr) {
      const workbook = await XlsxPopulate.fromBlankAsync()
      const data: any = []
      data.push([...inputKeys, ...transformedData[0]])
      mids.forEach((item: any) => {
        delete item.intentId
      })
      modifiedMidData.forEach((item: any, index: number) => {
        delete item.intentId
        data.push([...Object.values(item), ...transformedData[index + 1]])
      })
      workbook.sheet(0)?.cell('A1').value(data)
      const date = new Date()
      const initialTime = date.getTime()
      const blob = await workbook.outputAsync({
        type: 'blob',
        password: password,
      })
      console.log('Encryption time is : ', new Date().getTime() - initialTime, ' milliseconds')
      var url = window.URL.createObjectURL(blob as Blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = `merchantResult_${fileName}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } else {
      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const data: any = []
        data.push([...inputKeys, ...transformedData[0]])
        modifiedMidData.map((item: any, index: number) => {
          data.push([...Object.values(item), ...transformedData[index + 1]])
        })

        workbook.sheet(0)?.cell('A1').value(data)

        const blob = await workbook.outputAsync({
          type: 'blob',
        })
        var url = window.URL.createObjectURL(blob as Blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = `merchantResult_${fileName}.xlsx`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }
  }

  const passwordRegex = /^(?=.*\d)(?=.*[a-zA-Z]).*$/
  const isValidPassword = password?.length > 5 && passwordRegex.test(password)
  return (
    <Box flex={1} bg="WHITE" align="center" overflow={'auto'} pv={10}>
      <FileSelector
        innerCompTitle="Please upload merchant list file"
        onFileSelect={readExcel}
        fileType=".xlsx"
        filename={filename}
      />
      <Spacer size={16} />
      <Box width={240}>
        <TextInput
          value={delay.toString()}
          onChange={(val) => {
            if (!isNaN(val)) {
              setDelay(+val)
            }
          }}
          label="Set delay"
        />
      </Box>
      <Spacer size={16} />
      <Box width={240}>
        <TextInput value={password} onChange={setPassword} label="Set password" secureTextEntry={true} />
      </Box>
      <Box flexDirection={'row'} justifyContent="center" alignSelf={'stretch'} gap={16} flexWrap={'wrap'}>
        <ButtonNew
          isLoading={bulkAPIGOnboardingLoading}
          disabled={!wsdata}
          paddingVertical={16}
          title={'Register user'}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkAPIGOnboarding, setBulkAPIGOnboardingLoading, 'register_user')
          }}
        />
        <ButtonNew
          isLoading={bulkGrantPermissionLoading}
          disabled={!wsdata}
          paddingVertical={16}
          title={'Grant permissions'}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkGrantPermission, setBulkGrantPermissionLoading, 'grant_permissions')
          }}
        />
        <ButtonNew
          isLoading={bulkInsertMerchantLoading}
          disabled={!wsdata}
          title={'Insert Merchant'}
          paddingVertical={16}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkInsertMerchant, setBulkInsertMerchantLoading, 'insert_merchant')
          }}
        />
        <ButtonNew
          isLoading={bulkAddConfigLoading}
          disabled={!wsdata}
          title={'Add merchant config'}
          paddingVertical={16}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkAddConfig, setBulkAddConfigLoading, 'add_Config')
          }}
        />
        <ButtonNew
          isLoading={bulkAddConfigListLoading}
          disabled={!wsdata}
          title={'Add merchant config list'}
          paddingVertical={16}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkAddConfigList, setBulkAddConfigListLoading, 'add_config_list')
          }}
        />
        <ButtonNew
          isLoading={bulkCreateVpaLoading}
          disabled={!wsdata}
          title={'Create vpa'}
          paddingVertical={16}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkCreateVpa, setBulkCreateVpaLoading, 'create_vpa', false, true)
          }}
        />
      </Box>
      <Spacer size={32} />
      <Box flexDirection={'row'} justifyContent="center" alignSelf={'stretch'} gap={16} flexWrap={'wrap'}>
        <ButtonNew
          isLoading={csoOnboardLoading}
          disabled={!wsdata}
          title={'CSO Onboard'}
          type="primary"
          onPress={() => {
            onBulkUpload(insertCso, setCsoOnboardLoading, 'cso_onboard')
          }}
        />
        <ButtonNew
          isLoading={bulkGenerateQRLoading}
          disabled={!wsdata || !isValidPassword}
          title={'Generate QR'}
          type="primary"
          onPress={() => {
            onBulkUpload(bulkGenerateQR, setBulkGenerateQRLoading, 'generate_qr', true)
          }}
        />
      </Box>
      <Spacer size={32} />
      <ButtonNew
        title={'Sample file'}
        type="tertiary"
        onPress={() => {
          sampleFileDownload('Sample_merchant_onboarding_file')
        }}
      />
      {loading && (
        <Box
          backgroundColor={'TRANSPARENT'}
          position={'absolute'}
          left={0}
          right={0}
          top={0}
          bottom={0}
          alignItems="center"
          justify="center">
          <LoaderNew color={'PRIMARY'} type="large" />
        </Box>
      )}
    </Box>
  )
})

export default BulkMerchantOnboarding
